<template>
  <sidebar-nav>
    <toggle/>
    <menubar-link :to="{name: 'admin-modules', params: {organization: id}}">
      <template slot="name">Modules</template>
      <template slot="icon"><i class="fas fa-folder"></i></template>
    </menubar-link>
    <menubar-link :to="{name: 'admin-media', params: {organization: id}}">
      <template slot="name">Media</template>
      <template slot="icon"><i class="fas fa-photo-video"></i></template>
    </menubar-link>
    <menubar-link :to="{name: 'admin-members', params: {organization: id}}">
      <template slot="name">Members</template>
      <template slot="icon"><i class="fas fa-user"></i></template>
    </menubar-link>
    <menubar-link :to="{name: 'admin-groups', params: {organization: id}}">
      <template slot="name">Groups</template>
      <template slot="icon"><i class="fas fa-users"></i></template>
    </menubar-link>
    <menubar-link :to="{name: 'admin-access-requests', params: {organization: id}}">
      <template slot="name">Access Requests</template>
      <template slot="icon"><i class="fas fa-sign-in-alt"></i></template>
    </menubar-link>
    <menubar-link :to="{name: 'admin-suggestions', params: {organization: id}}">
      <template slot="name">Suggestions</template>
      <template slot="icon"><i class="fas fa-lightbulb"></i></template>
    </menubar-link>
    <menubar-link :to="{name: 'admin-reports', params: {organization: id}}">
      <template slot="name">Reports</template>
      <template slot="icon"><i class="fas fa-chart-bar"></i></template>
    </menubar-link>
    <menubar-link :to="{name: 'admin-bioreq', params: {organization: id}}">
      <template slot="name">Bioreq</template>
      <template slot="icon"><i class="fas fa-dna"></i></template>
    </menubar-link>
  </sidebar-nav>
</template>

<script>
import menubarLink from '../common/menubar-link'
import sidebarNav from './sidebar-nav'
import toggle from './toggle'

export default {
  components: {
    menubarLink,
    sidebarNav,
    toggle
  },
  computed : {
    id () {
      return this.$route.params.organization
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/sidebar/master.vue